import React from "react";
import { Box, LinearProgress, Typography } from "@mui/material";
import { evaluatePasswordStrength } from "../utils/passwordValidation";

const PasswordStrengthIndicator = ({ password }) => {
  if (!password) return null;

  const { percent, label, color } = evaluatePasswordStrength(password);

  return (
    <Box sx={{ mt: 0.5, mb: 1 }}>
      <LinearProgress
        variant="determinate"
        value={percent}
        sx={{
          height: 6,
          borderRadius: 3,
          backgroundColor: "#e0e0e0",
          "& .MuiLinearProgress-bar": { backgroundColor: color },
        }}
      />
      <Typography variant="caption" sx={{ color, fontWeight: 600 }}>
        Seguridad de la contraseña: {label}
      </Typography>
    </Box>
  );
};

export default PasswordStrengthIndicator;
